"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@emotion/core");

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var R = _interopRequireWildcard(require("ramda"));

var filestack = _interopRequireWildcard(require("filestack-js"));

var _pickerOverlay = _interopRequireDefault(require("./picker-overlay"));

var _uploaderTypes = require("./uploader-types.const");

var _filePreview = _interopRequireDefault(require("./file-preview"));

var _inputLabel = _interopRequireDefault(require("../input-label"));

var _localization = _interopRequireDefault(require("../../localization"));

var _allowedFormats, _uploadIcons, _pickerOptionsByType;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { keys.push.apply(keys, Object.getOwnPropertySymbols(object)); } if (enumerableOnly) keys = keys.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var allowedFormats = (_allowedFormats = {}, _defineProperty(_allowedFormats, _uploaderTypes.uploaderTypes.VIDEO, ['.mp4', '.mov', '.wmv', '.avi']), _defineProperty(_allowedFormats, _uploaderTypes.uploaderTypes.FILE, ['.key', '.odp', '.pps', '.ppt', '.pptx', '.ods', '.xls', '.xlsx', '.csv', '.doc', '.docx', '.odt', '.pdf', '.rtf', '.tex', '.txt', '.wpd']), _defineProperty(_allowedFormats, _uploaderTypes.uploaderTypes.IMAGE, ['.jpeg', '.jpg', '.jfif', '.png', '.svg']), _allowedFormats);
var uploadIcons = (_uploadIcons = {}, _defineProperty(_uploadIcons, _uploaderTypes.uploaderTypes.VIDEO, 'https://static.influitive.com/file-uploader/video.svg'), _defineProperty(_uploadIcons, _uploaderTypes.uploaderTypes.FILE, 'https://static.influitive.com/file-uploader/file-add.svg'), _defineProperty(_uploadIcons, _uploaderTypes.uploaderTypes.IMAGE, 'https://static.influitive.com/file-uploader/image.svg'), _uploadIcons);
var pickerOptionsByType = (_pickerOptionsByType = {}, _defineProperty(_pickerOptionsByType, _uploaderTypes.uploaderTypes.VIDEO, {
  exposeOriginalFile: true,
  fromSources: ['local_file_system', 'video', 'url'],
  accept: R.append('video/vnd.avi', allowedFormats.video),
  maxSize: 100 * 1024 * 1024
}), _defineProperty(_pickerOptionsByType, _uploaderTypes.uploaderTypes.FILE, {
  fromSources: ['local_file_system', 'url'],
  accept: allowedFormats.file,
  maxSize: 100 * 1024 * 1024
}), _defineProperty(_pickerOptionsByType, _uploaderTypes.uploaderTypes.IMAGE, {
  fromSources: ['local_file_system', 'webcam', 'url'],
  accept: allowedFormats.image,
  imageMax: [8000, 8000],
  maxSize: 50 * 1024 * 1024
}), _pickerOptionsByType);
var pickerCustomTextKeys = {
  NOT_ACCEPTED_FILE_TYPE: 'File {displayName} is not an accepted file type. The accepted file types are {types}'
};
var FileUploader = R.pipe(function (_ref) {
  var apiKey = _ref.apiKey,
      customPickerOptions = _ref.customPickerOptions,
      id = _ref.id,
      height = _ref.height,
      required = _ref.required,
      label = _ref.label,
      lang = _ref.lang,
      type = _ref.type,
      onError = _ref.onError,
      onSuccess = _ref.onSuccess,
      removeFile = _ref.removeFile,
      bucket = _ref.bucket,
      path = _ref.path,
      fileHandle = _ref.fileHandle;

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      previewSettings = _useState2[0],
      setPreviewSettings = _useState2[1];

  var customTexts = {
    title: _localization.default.t("Drop your ".concat(type, " here or browse")),
    mobileTitle: type == 'video' ? _localization.default.t("Tap to browse or record a video") : _localization.default.t("Drop your ".concat(type, " here or browse")),
    subTitle: R.join(' ', allowedFormats[type]),
    startRecording: _localization.default.t('Start recording'),
    stopRecording: _localization.default.t('Stop recording'),
    takePhoto: _localization.default.t('Take photo'),
    retake: _localization.default.t('Retake')
  };
  var uploadIcon = uploadIcons[type];

  var setupPreview = function setupPreview(response) {
    setPreviewSettings({
      removeFile: R.pipe(removeFile, function () {
        return setPreviewSettings(null);
      }),
      url: response.url,
      container: response.container,
      filename: response.filename,
      path: response.key,
      handle: response.handle,
      height: height
    });
    return response;
  };

  var defaultPickerOptions = R.mergeDeepRight({
    lang: R.take(2, lang),
    storeTo: {
      location: 's3',
      container: bucket,
      path: "".concat(path, "/"),
      access: 'private',
      region: 'us-east-1'
    },
    customText: _defineProperty({}, pickerCustomTextKeys.NOT_ACCEPTED_FILE_TYPE, _localization.default.t('File {displayName} is not an accepted file type. The accepted file types are {{types}}', {
      types: R.join(', ', allowedFormats[type])
    }))
  }, pickerOptionsByType[type]);
  var pickerOptions = {
    apiKey: apiKey,
    onSuccess: R.pipe(setupPreview, onSuccess),
    onError: onError,
    pickerOptions: R.mergeDeepRight(defaultPickerOptions, customPickerOptions)
  };
  var labelHidden = label === '';
  (0, _react.useEffect)(function () {
    if (fileHandle) {
      var client = filestack.init(apiKey);
      client.metadata(fileHandle).then(function (response) {
        return setupPreview(_objectSpread({}, response, {
          url: "".concat(client.session.urls.cdnUrl, "/").concat(response.handle)
        }));
      });
    }
  }, []);
  return {
    id: id,
    height: height,
    required: required,
    label: label,
    labelHidden: labelHidden,
    pickerOptions: pickerOptions,
    previewSettings: previewSettings,
    customTexts: customTexts,
    uploadIcon: uploadIcon,
    type: type
  };
}, function (_ref2) {
  var id = _ref2.id,
      height = _ref2.height,
      required = _ref2.required,
      label = _ref2.label,
      labelHidden = _ref2.labelHidden,
      pickerOptions = _ref2.pickerOptions,
      previewSettings = _ref2.previewSettings,
      customTexts = _ref2.customTexts,
      uploadIcon = _ref2.uploadIcon,
      type = _ref2.type;
  return (0, _core.jsx)("div", {
    id: "".concat(id, "-container")
  }, (0, _core.jsx)(_inputLabel.default, {
    id: id,
    required: required,
    labelHidden: labelHidden
  }, label), previewSettings === null ? (0, _core.jsx)(_pickerOverlay.default, _extends({
    containerId: id,
    height: height,
    customTexts: customTexts,
    uploadIcon: uploadIcon,
    type: type
  }, pickerOptions)) : (0, _core.jsx)(_filePreview.default, previewSettings));
});
FileUploader.propTypes = {
  apiKey: _propTypes.default.string,
  bucket: _propTypes.default.string,
  id: _propTypes.default.string,
  customPickerOptions: _propTypes.default.object,
  height: _propTypes.default.string,
  label: _propTypes.default.string,
  lang: _propTypes.default.string,
  onError: _propTypes.default.func,
  onSuccess: _propTypes.default.func,
  required: _propTypes.default.bool,
  removeFile: _propTypes.default.func,
  path: _propTypes.default.string,
  type: _propTypes.default.string,
  fileHandle: _propTypes.default.string
};
FileUploader.defaultProps = {
  customPickerOptions: {},
  label: '',
  removeFile: function removeFile(container, path) {
    return console.log({
      container: container,
      path: path
    });
  },
  required: false,
  type: 'video',
  lang: 'en'
};
var _default = FileUploader;
exports.default = _default;